import { NotificationManager } from '@lst/mk-react-uikit';
import React from 'react';
import { useTranslation } from 'react-i18next';

const Notifications = () => {
  const { t } = useTranslation();

  const inviteSendMessage = t('Приглашение отправлено');
  const inviteSendErrorMessage = t('Внутренняя ошибка при отправке приглашения');

  const updateVisibilitySetting = t('Настройки видимости вашего профиля сохранены');
  const errorUpdatingVisibilitySettings = t('Внутренняя ошибка при обновлениии настроек видимости');

  const nicknameCopyMessage = t('Имя игрока скопировано');
  const nicknameCopyErrorMessage = t('Не удалось скопировать имя игрока');

  window.notificationMessages = {
    inviteSendMessage,
    inviteSendErrorMessage,
    updateVisibilitySetting,
    errorUpdatingVisibilitySettings,
    nicknameCopyMessage,
    nicknameCopyErrorMessage,
  };

  return <NotificationManager />;
};

export default Notifications;
